import { useDispatch, useSelector } from 'react-redux'
import { SelectCustom } from '../../../selectCustom'
import { changeSource, selectSource, selectSources } from '../store/slice'
import { getDataAvailability } from '../store/thunk'
import useGetOrganizationId from '../useGetOrganizationId'

export const SourceSelect = ({ orgId }) => {
  const dispatch = useDispatch()

  const organizationId = useGetOrganizationId(orgId)

  const sources = useSelector(selectSources)
  const source = useSelector(selectSource)

  const chooseItem = (item) => {
    dispatch(changeSource(item.value))
    dispatch(
      getDataAvailability({
        organizationId,
        sourceOrganizationId: item.value || 0,
      }),
    )
  }

  const sourceDetail =
    sources.find((item) => item.sourceOrganizationId === source) || {}

  return (
    <SelectCustom
      zIndex={13}
      className="mx2"
      activeItem={{
        label: sourceDetail.name,
        value: sourceDetail.sourceOrganizationId,
      }}
      data={sources.map((item) => ({
        ...item,
        label: item.name,
        value: item.sourceOrganizationId,
        isI18n: false,
      }))}
      chooseItem={chooseItem}
      isI18n
      isNoWrap
    />
  )
}
